import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import AuthCallback from "./auth/AuthCallback";
import Login from "./pages/Login";
import MyTrips from "./pages/MyTrips";
import MyProfile from "./pages/MyProfile";
import NewTrip from "./pages/NewTrip";
import CreateTripWizard from "./pages/CreateTripWizard";
import Home from "./pages/Home";
import AllDays from "./pages/AllDays";
import DayDetail from "./pages/DayDetail";
import PlaceDetail from "./pages/PlaceDetail";
import FullMap from "./pages/FullMap";
import ARView from "./pages/ARView";
import Logistics from "./pages/Logistics";
import Tickets from "./pages/Tickets";
import Phrases from "./pages/Phrases";
import Events from "./pages/Events";
import Journal from "./pages/Journal";
import FreeTours from "./pages/FreeTours";
import Tips from "./pages/Tips";
import Currency from "./pages/Currency";
import SaboresHub from "./pages/SaboresHub";
import Favorites from "./pages/Favorites";
import SharedView from "./pages/SharedView";
import TripShell from "./components/TripShell";
import ScrollToTop from "./components/ScrollToTop";

function RootRedirect() {
  const { user, loading } = useAuth();
  // Use a thin loader until auth state is known
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-sm text-[hsl(var(--muted))]">Cargando…</p>
      </div>
    );
  }
  if (user) {
    window.location.replace("/viajes");
  } else {
    window.location.replace("/login");
  }
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Synchronously check for session_id in URL hash (OAuth callback)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/viajes" element={<MyTrips />} />
      <Route path="/viajes/nuevo" element={<NewTrip />} />
      <Route path="/crear-viaje" element={<CreateTripWizard />} />
      <Route path="/perfil" element={<MyProfile />} />
      <Route path="/v/:token" element={<SharedView />} />

      {/* Trip routes (shared bottom nav + context) */}
      <Route path="/viaje/:tripId" element={<TripShell />}>
        <Route index element={<Home />} />
        <Route path="dias" element={<AllDays />} />
        <Route path="dia/:dayId" element={<DayDetail />} />
        <Route path="lugar/:placeId" element={<PlaceDetail />} />
        <Route path="map" element={<FullMap />} />
        <Route path="ar" element={<ARView />} />
        <Route path="logistica" element={<Logistics />} />
        <Route path="sabores" element={<SaboresHub />} />
        <Route path="restaurantes" element={<SaboresHub />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="frases" element={<Phrases />} />
        <Route path="eventos" element={<Events />} />
        <Route path="diario" element={<Journal />} />
        <Route path="tours" element={<FreeTours />} />
        <Route path="tips" element={<Tips />} />
        <Route path="cambio" element={<Currency />} />
        <Route path="favoritos" element={<Favorites />} />
      </Route>
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js").catch(() => {});
      });
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
